import { ProductSheetLanguages } from "@tfg/types/constants/language.constants"
import { AGECResponses } from "@tfg/types/endpoints/agec"

import { GetProductPageComponentsResponseDto } from "~/gen/api"

export type IframeMessageType =
  | "AGEC_DATA"
  | "STYLE_DATA"
  | "CONFIGURATION_DATA"
  | "PRODUCT_PAGE_COMPONENTS"
  | "PRODUCT_SHEET_GROUP"
  | "ACTIVE_LANGUAGES"

export interface IframeMessage {
  type: IframeMessageType
  payload: unknown
}

export interface IframeRefs {
  style: React.RefObject<HTMLIFrameElement>
  searchEngine: React.RefObject<HTMLIFrameElement>
}

export const sendMessagesToIframe = (
  iframeRef: React.RefObject<HTMLIFrameElement>,
  message: IframeMessage
): void => {
  const iframeWindow = iframeRef.current?.contentWindow
  if (iframeWindow) {
    iframeWindow.postMessage(message, "*")
  }
}

export const createIframeMessages = (
  styleData: unknown,
  configurations: unknown,
  agecData: AGECResponses.GenericAgecData,
  productPageComponents: GetProductPageComponentsResponseDto[],
  selectedProductSheetGroup: unknown,
  activeLanguages: ProductSheetLanguages[]
) => ({
  styleIframe: [
    { type: "AGEC_DATA" as const, payload: agecData },
    { type: "STYLE_DATA" as const, payload: styleData },
    { type: "CONFIGURATION_DATA" as const, payload: configurations },
    {
      type: "PRODUCT_PAGE_COMPONENTS" as const,
      payload: productPageComponents,
    },
    {
      type: "ACTIVE_LANGUAGES" as const,
      payload: activeLanguages,
    },
  ],
  searchEngineIframe: [
    { type: "CONFIGURATION_DATA" as const, payload: configurations },
    { type: "STYLE_DATA" as const, payload: styleData },
    {
      type: "PRODUCT_SHEET_GROUP" as const,
      payload: selectedProductSheetGroup,
    },
  ],
})
